// `app/24/constants.js`. Applications closed on this date; the hero button and the
// countdown section both key off it, so it stays a real date rather than a flag.
export const DEADLINE = new Date('2024-11-13T23:59:59-03:00');
